const sidebarForm = document.querySelector('.side #sidebar .form-container');
import $ from 'jquery';

if (sidebarForm) {
    const formHeader = sidebarForm.querySelector('.form-container__header');
    const formPopup = sidebarForm.querySelector('.form-container__popup');

    if (formHeader && formPopup) {
        $(formPopup).hide()

        formHeader.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            $(formPopup).slideDown('fast')
        })

        formPopup.addEventListener('click', (e) => {
            e.stopPropagation();
        })

        document.addEventListener('click', (e) => {
            $(formPopup).slideUp('fast')
        })
    }
}